import { CONST_EMPTY_ARRAY } from 'utilities/consts/variable-types.js';
import { LegendsCheckboxFilterProps, LegendsFilters } from './legends-filters.js';
import { LegendsRadioFilterProps, LegendsRadioFilters } from './legends-radio-filters.js';

export const LegendsFilterWrapper = ({
  radioFilters = CONST_EMPTY_ARRAY,
  radioActiveFilter = CONST_EMPTY_ARRAY,
  radioFilterLabel,
  checkboxFilters,
  checkBoxFilterLabel,
  checkboxFilterOnClick,
  radioFilterOnClick,
}: LegendsCheckboxFilterProps & LegendsRadioFilterProps) => {
  return (
    <>
      <LegendsFilters
        checkboxFilters={checkboxFilters}
        checkboxFilterOnClick={checkboxFilterOnClick}
        checkBoxFilterLabel={checkBoxFilterLabel}
      />
      <LegendsRadioFilters
        radioFilters={radioFilters}
        radioActiveFilter={radioActiveFilter}
        radioFilterLabel={radioFilterLabel}
        radioFilterOnClick={radioFilterOnClick}
      />
    </>
  );
};
